import { Component } from '@angular/core';
import { CreatePharmacyComponent } from '../../../../components/admin-customer-shared-components/create-pharmacy-component/create-pharmacy-component';

@Component({
  selector: 'app-create-pharmacy',
  imports: [CreatePharmacyComponent],
  templateUrl: './create-pharmacy.html',
  styleUrl: './create-pharmacy.scss',
})
export class CreatePharmacy {}
